<template>
  <ClassForm />
</template>
  
<script>
  import ClassForm from '@/components/classes/ClassForm.vue';
  export default {
    name: "ClassCreatePage",
    components: {
      ClassForm,
    },
  };
</script>
  